import React from 'react'
import { useTranslation } from 'react-i18next'

import { FieldProps } from '../../../../../../../@types/types'
import { ObjectDetailsScreenValidationResult } from '../../../../../../../@types/validation-types'
import { Stepper } from '../../../../../../common/inputs/stepper/Stepper'

const MaxNumberOfPersons: React.FC<FieldProps<ObjectDetailsScreenValidationResult>> = ({
  screenName,
  insertionData,
  validationMessages,
  onChange,
  wrapperClassName,
}) => {
  const { t } = useTranslation()
  return (
    <div className={wrapperClassName}>
      <Stepper
        id='max-number-of-persons'
        propertyName='maxNumberOfPersons'
        label={t('wizard.screen.objectDetails.maxNumberOfPersons')}
        placeholder={t('wizard.screen.objectDetails.placeholder.amount')}
        input={insertionData.maxNumberOfPersons}
        type='tel'
        numericOnly
        min={0}
        max={9999}
        step={1}
        errors={validationMessages?.maxNumberOfPersons ?? []}
        doOnFieldChange={(property, value) => onChange({ screen: screenName, property }, value)}
      />
    </div>
  )
}
export default MaxNumberOfPersons
